import { Box } from "@mui/material";
import ServiceCard from "./serviceCard";
import { services } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setSelectedService } from "../../features/services/serviceSlice";

const ServicesList = () => {
  const selectedService = useSelector(
    (state: RootState) => state.service.value
  );
  const dispatch = useDispatch();

  const handleService = (index: number) => {
    dispatch(setSelectedService(index));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 3,
        justifyContent: "center",
      }}
    >
      {services.map((service, index) => (
        <Box
          key={index}
          sx={{
            width: {
              xs: "100%",
              sm: "calc(50% - 12px)",
              md: "calc(33.333% - 16px)",
            },
            minWidth: { xs: "100%", sm: "280px" },
 
          }}
        >
          <ServiceCard
            service={service}
            index={index}
            isSelected={selectedService === index}
            handleClick={handleService}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ServicesList;
